import { createHash } from "node:crypto";

export function resolveBillingWebhookMasterKey(input: {
	configured?: string;
	databaseUrl?: string;
}): string | undefined {
	const fromEnv = process.env.ATHENA_BILLING_WEBHOOK_MASTER_KEY?.trim();
	if (fromEnv && fromEnv.length > 0) {
		return fromEnv;
	}
	const configured = input.configured?.trim();
	if (configured && configured.length > 0) {
		return configured;
	}
	const databaseUrl = input.databaseUrl?.trim();
	if (databaseUrl && databaseUrl.length > 0) {
		return createHash("sha256")
			.update(`athena-billing-webhook-secrets:${databaseUrl}`, "utf8")
			.digest("hex");
	}
	return undefined;
}
